const Keys = {
  SelectedAccountId: 'SelectedAccountId',
};

export const landingPageSelectionLocalStorageKey = 'landingPageSelection';
export const landingPagePathnames = ['/', '/ads'];

/** Reads the landing page stored by `useLocalStorageState`, which JSON-encodes its values. */
export const getLandingPagePath = () => {
  try {
    const value = JSON.parse(localStorage.getItem(landingPageSelectionLocalStorageKey) ?? 'null');
    return landingPagePathnames.includes(value) ? (value as string) : undefined;
  } catch {
    return undefined;
  }
};

export const getSelectedAccountId = () => {
  const value = localStorage.getItem(Keys.SelectedAccountId);
  const id = Number(value);
  if (!id || isNaN(id)) {
    return undefined;
  }
  return id;
};

export const setSelectedAccountId = (id?: number) => {
  if (id) {
    localStorage.setItem(Keys.SelectedAccountId, id.toString());
  } else {
    localStorage.removeItem(Keys.SelectedAccountId);
  }
};
